import '../../sass/pages/_ranking100Years.scss';

// Modules
import Ranking from "../components/ranking";

import { apiService } from "../services/api";
const api = new apiService()

import { loadButterflys } from "../utils/helpers";

// Libraries
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener('load', () => {
	ranking100Years()
})

export const ranking100Years = async () => {
    loadButterflys("ranking")

    const response: any = await api.getRankingData()
    loadAnimation()

    new Ranking({
        wrapperUserId: '#infoUser',
        wrapperRankingListId: '#rankingList',
        userData: response.my_ranking,
        rankingList: response.all_ranking,
        prefix: 'ca'
    })
}

function loadAnimation() {
    gsap.to('.ca-ranking__image ,.ca-ranking__title, .ca-ranking__desc, #rankingButtons', { duration: 1, opacity: 1, translateY: 0, ease: 'power1.inOut' })
}